__turbopack_context__.v({
  "className": "suisscond_dff6d526-module__zjDLYW__className",
  "variable": "suisscond_dff6d526-module__zjDLYW__variable",
});
